var color = require('color');
exports.Color = color;